import axios from 'axios';
/**
 * Métricas para mixpanel
 */
export const sendMetric = (event, params) => {
  const data = {
    params: params,
    event: event
  };
  // return  axios.post('http://localhost:7000/action/mixpanel', data);
}



// WEBPACK FOOTER //
// ./src/services/mixpanel.js